import React from "react";
import { Icon } from 'rhombus-react';

import { TextOverflow } from "utils/common";

export default function VariableInfoCell({ name, data, onClick, requiredIcon, iconName }){
	return (
		<td className="edit-version-main variable-info-cell" onClick={onClick}>
			<div className="variable-name">
				<div className="flex-only">
					<TextOverflow value={name} />
					<Icon name={requiredIcon} />
				</div>
				{iconName && <Icon name = {iconName} />}
			</div>
			<div className="variable-data">
				<TextOverflow value={data} />
			</div>
		</td>
	);
}

VariableInfoCell.displayName = "VariableInfoCell";
